/**
 * @property {string|null} id
 * @property {string|null} name
 */
export default class Textbase {
    constructor() {
        this.id = null;
        this.name = null;
    }

    /**
     * Returns a new `Textbase` instance hydrated with data from given `api_resource`.
     *
     * @param {object} api_resource
     * @return {Textbase}
     */
    static fromAPI(api_resource) {
        return Object.assign(new Textbase(), {
            id: api_resource.id,
            name: api_resource.name
        });
    }
}
